/**
 * Configuração de URLs do backend.
 * Em desenvolvimento: usa REACT_APP_API_URL se definida, senão http://localhost:3001.
 * Em produção: use REACT_APP_API_URL (ex: no painel da Vercel).
 * Se o checkout rodar em subdomínio (ex: checkout.hotlize.com) e a API em outro host,
 * defina REACT_APP_API_URL com a origem do backend para que o polling de checkout-status funcione.
 */
const isDev = process.env.NODE_ENV === 'development';
const envApiUrl = (process.env.REACT_APP_API_URL || '').trim().replace(/\/$/, '');
const backendOrigin = isDev
    ? (envApiUrl || 'http://localhost:3001')
    : envApiUrl;

/** Base URL para chamadas à API (axios baseURL). Em dev e prod usa a origem do backend para evitar 404 por proxy. */
export const apiBaseURL = backendOrigin ? `${backendOrigin}/api` : '/api';

/** Origem do backend (para recursos estáticos, ex: /group_photos). */
export const backendOriginForAssets = backendOrigin || (typeof window !== 'undefined' && window.location.port === '3000' ? 'http://localhost:3001' : '');
